import React from 'react'
import { Formik, Form } from 'formik';
import FieldsGroup from 'Elements/FieldsGroup'
import { useSelector, useDispatch } from 'react-redux';
import { scrollToTop, yupValidation, fieldsToFormik, fieldsValidation } from '@/Helper'
import { addColor, resetStatusColor } from 'Reduxes/inventory/configuration/color/colorActions'
import Button from 'Elements/Button';
import Alert from 'Comps/elements/Alert'
import { validationSchema } from './validation'
import { serverValue } from 'Configs/Form'

const FormNew = (props) => {

    const { goToIndex, fieldGroup } = props;
    const { data, success, error, loading } = useSelector(state => state.colorReducer)
    const dispatch = useDispatch();
    const formOpts = {
        initialValues: fieldsToFormik(fieldGroup),
        validationSchema,
        onSubmit: async (values, { setSubmitting, resetForm }) => {

            values.code = values.code.toUpperCase();
            let cleanVal = serverValue(values);
            let result = await dispatch(addColor(cleanVal))

            if (result) {
                resetForm();
                goToIndex();
            }

            setSubmitting(false)
            scrollToTop()
        }
    }

    return (
        <>
            {
                error && <Alert hide={() => dispatch(resetStatusColor())} option={{ type: 'error', message: error }} />
            }
            <Formik {...formOpts}>
                {(formik) => {
                    const { initialValues, values, isSubmitting } = formik;
                    return (
                        <Form className="form-member form-color">
                            <FieldsGroup fields={fieldGroup} />
                            <div className="fields-group-container buttons">
                                <Button
                                    type="submit"
                                    style="OrangeMdWide"
                                    label={isSubmitting ? 'Saving' : 'Save'}
                                    icon={isSubmitting ? 'spinner' : null}
                                    disabled={isSubmitting} />
                                <button disabled={isSubmitting} onClick={goToIndex} type="button" className="btn btn-md btn-wide">Cancel</button>
                            </div>
                        </Form>
                    )
                }}
            </Formik>
        </>
    )
}

export default FormNew